<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="50%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="零件编号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.partCode" placeholder="零件编号"></el-input> -->
                        {{dataForm.partCode}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.partName" placeholder="零件名称"></el-input> -->
                        {{dataForm.partName}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单车用量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="oneCarCount" style="margin-bottom: 0;">
                        <!-- <el-input
                                v-model="dataForm.oneCarCount"
                                placeholder="单车用量"

                            ></el-input> -->
                        <!-- <ctl-number v-model="dataForm.oneCarCount" :min="0" :max="999" label="描述文字"></ctl-number> -->
                        {{dataForm.oneCarCount}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="是否暂估" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="provisionalEstimate" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.provisionalEstimate" placeholder="是否暂估"></el-input> -->
                        {{dataForm.provisionalEstimate}}
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="分摊金额" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="shareMoney" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.shareMoney" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="净价" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="sharePriceWithoutTax" style="margin-bottom: 0;">
                        <!-- <el-input
                                    v-model="dataForm.sharePriceWithoutTax"
                                    placeholder="未税含模摊单价"

                                ></el-input> -->
                        <!-- <ctl-number v-model="dataForm.sharePriceWithoutTax" :precision="3" :min="0" :max="999"></ctl-number> -->
                        {{dataForm.sharePriceWithoutTax}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="未税总价（净价）" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="sharePriceWithoutTaxSap" style="margin-bottom: 0;">
                        <!-- <el-input
                                v-model="dataForm.priceWithoutTax"
                                placeholder="未税单价"

                            ></el-input> -->
                        <!-- <ctl-number v-model="dataForm.priceWithoutTax" :precision="3" :min="0" :max="999"></ctl-number> -->
                        {{dataForm.sharePriceWithoutTaxSap}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="未税单台金额" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="oneCarPriceWithoutTax" style="margin-bottom: 0;">
                        <!-- <el-input
                                    v-model="dataForm.oneCarPriceWithoutTax"
                                    placeholder="单台金额（未税）"

                                ></el-input> -->
                        <!-- <ctl-number v-model="dataForm.oneCarPriceWithoutTax" :precision="3" :min="0" :max="999"></ctl-number> -->
                        {{dataForm.oneCarPriceWithoutTax}}
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="模摊数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="shareCount" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.shareCount" :precision="3" :min="0" :max="999"></ctl-number>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="订单单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="unit" style="margin-bottom: 0;">
                        <el-select size="small" v-model="dataForm.unit" placeholder="请选择类型" clearable>
                            <el-option v-for="item in UNIT" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                 <el-descriptions-item label="转换分子" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="conversionMolecule" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.conversionMolecule" placeholder="转换分子"></el-input>
                        {{dataForm.conversionMolecule}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="转换分母" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="conversionDenominator" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.conversionDenominator" placeholder="转换分母"></el-input>
                        {{dataForm.conversionDenominator}}
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="板材结算单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="kmein" style="margin-bottom: 0;">
                        <el-select size="small" v-model="dataForm.kmein" placeholder="请选择类型" clearable>
                            <el-option v-for="item in UNIT" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="备注" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="remark" style="margin-bottom: 0;">
                        <!-- <el-input
                                    v-model="dataForm.oneCarPriceWithoutTax"
                                    placeholder="单台金额（未税）"

                                ></el-input> -->
                        <el-input v-model="dataForm.remark"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    UNIT,
} from '@/utils/const'
import {
    getPriceAgreementPartListById,
    createPriceAgreementPartList,
    editPriceAgreementPartListRfq
} from "@/controller/priceAgreement";
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            UNIT:UNIT,
            viewData: {},
            rateValue: '',
            dataForm: {
                partCode: '',
                partName: '',
                oneCarCount: '',
                priceWithoutTax: '',
                shareMoney: '',
                sharePriceWithoutTax: '',
                oneCarPriceWithoutTax: '',
                provisionalEstimate: '',
                priceAgreementId: '',
                shareCount: '',
                unit:'',
                kmein:'',
                conversionMolecule:'',
                conversionDenominator:'',
                remark: ''
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(priceAgreementId, id, rateValue) {
            console.log(id)
            this.dataForm.id = id || 0;
            this.dataForm.priceAgreementId = priceAgreementId
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查零件
                    getPriceAgreementPartListById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                            this.dataForm.shareMoney = rateValue ? Number(Number(this.dataForm.sharePriceWithoutTax * (1 - rateValue / 100)).toFixed(3)) : 0
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let partListParams = {
                        id: this.dataForm.id || undefined,
                        partCode: this.dataForm.partCode,
                        partName: this.dataForm.partName,
                        oneCarCount: this.dataForm.oneCarCount,
                        priceWithoutTax: this.dataForm.priceWithoutTax,
                        shareMoney: this.dataForm.shareMoney,
                        sharePriceWithoutTax: this.dataForm.sharePriceWithoutTax,
                        oneCarPriceWithoutTax: this.dataForm.oneCarPriceWithoutTax,
                        provisionalEstimate: this.dataForm.provisionalEstimate,
                        shareCount: this.dataForm.shareCount,
                        priceAgreementId: this.dataForm.priceAgreementId,
                        unit:this.dataForm.unit,
                        kmein:this.dataForm.kmein,
                        conversionMolecule:this.dataForm.conversionMolecule,
                        conversionDenominator:this.dataForm.conversionDenominator,
                        remark: this.dataForm.remark
                    };
                    if (this.dataForm.id) {
                        // 更新零件清单
                        editPriceAgreementPartListRfq(partListParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        console.log(partListParams)
                        // 创建零件清单
                        createPriceAgreementPartList(partListParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 243.5px; text-align: left;'
        },
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
